// Custom function to create a suspense-compatible resource
export default function createResource(asyncFn) {
  let status = 'pending';
  let result;
  let suspender = asyncFn().then(
    (r) => {
      status = 'success';
      result = r;
    },
    (e) => {
      status = 'error';
      result = e;
    },
  );

  return {
    read() {
      if (status === 'pending') {
        throw suspender;
      } else if (status === 'error') {
        throw result;
      } else if (status === 'success') {
        return result;
      }
    },
  };
}
